import { useRef, useCallback } from 'react';
import { useLayoutEffect } from './useLayoutEffect';
export function useEventCallback(callback) {
  const ref = useRef(callback);
  useLayoutEffect(() => {
    ref.current = callback;
  });
  return useCallback((evt, ...args) => ref.current(evt, ...args), []);
}